export default "__VITE_ASSET__377b8581__"